import { LocaleContextController } from '@/hoslog-intl';
import { ApiClientContextController } from '@/react-query/context/ApiClientContextController';
import { AuthContextController } from '../context/auth/authContextController/AuthContextController';
import LocaleLoader from '../context/locale/LoadLocaleController';
import { AppProvidersProps } from './AppProviders.types';

export const AppProviders = ({ children }: AppProvidersProps) => (
  <LocaleContextController>
    <LocaleLoader>
      <ApiClientContextController>
        <AuthContextController>{children}</AuthContextController>
      </ApiClientContextController>
    </LocaleLoader>
  </LocaleContextController>
);
